import choVayConst from "../../../../constants/choVayConst";
import { LaiSuatText2 } from "../../../../constants/choVayConst";
import React from "react";
import { formatNumber } from "utils/currencyFormat";
import { getDate } from "utils/formatDate";

export const ThongTinHopDong = ({ dataThongTinTra, hopdong, item }) => {
  return (
    <div className="from-ndtra">
      <div class="from-thongtintra" style={{ marginTop: "10px" }}>
        <p>
          <div className="row">
            <div className="col-label-thong-tin-hd color7-bold">
              {" "}
              Thanh toán cho hợp đồng:{" "}
            </div>
            <div className="col-3 text-left  text-normal color7">
              <span className="color-xanh-bold">
                {dataThongTinTra.MaHopDong}
              </span>
            </div>
          </div>
        </p>
        <p>
          <div className="row">
            <div className="col-label-thong-tin-hd color7-bold">Chủ nợ: </div>
            <div className="col-3 text-left  text-normal color7">
              <span>{dataThongTinTra.TenChuNo}</span>
            </div>
          </div>
        </p>
        <p>
          <div className="row">
            <div className="col-label-thong-tin-hd color7-bold">
              Ngày sinh:{" "}
            </div>
            <div className="col-3 text-left  text-normal color7">
              <span>{getDate(dataThongTinTra.NgaySinh)}</span>
            </div>
          </div>
        </p>
        <p>
          <div className="row">
            <div className="col-label-thong-tin-hd color7-bold">Địa chỉ: </div>
            <div className="col-3 text-left  text-normal color7">
              <span>{dataThongTinTra.DiaChi}</span>
            </div>
          </div>
        </p>
      </div>
      <div class="from-thongtintra">
        <p>
          <div className="row">
            <div className="col-label-thong-tin-hd color7-bold">
              Số tiền vay:
            </div>
            <div className="col-3 text-left  text-normal color7">
              <span className="color-do-bold">
                {" "}
                {formatNumber(dataThongTinTra.SoTienVay)}(vnđ)
              </span>
            </div>
          </div>
        </p>
        <p>
          <div className="row">
            <div className="col-label-thong-tin-hd color7-bold">Ngày vay:</div>
            <div className="col-3 text-left  text-normal color7">
              <span>{getDate(dataThongTinTra.NgayVay)}</span>
            </div>
          </div>
        </p>
        <p>
          <div className="row">
            <div className="col-label-thong-tin-hd color7-bold">Ngày trả:</div>
            <div className="col-3 text-left  text-normal color7">
              <span>{getDate(dataThongTinTra.NgayTra)}</span>
            </div>
          </div>
        </p>{" "}
        <p>
          <div className="row">
            <div className="col-label-thong-tin-hd color7-bold">
              Tổng tiền lãi:{" "}
            </div>
            <div className="col-3 text-left color7 color-do-bold">
              <span>{formatNumber(dataThongTinTra.TongTienLai)} (vnđ)</span>
            </div>
          </div>
        </p>{" "}
        <p>
          <div className="row">
            <div className="col-label-thong-tin-hd color7-bold">
              Tổng tiền phải trả:{" "}
            </div>
            <div className="col-3 text-left   color7 color-do-bold">
              <span> {formatNumber(dataThongTinTra.TongTienPhaiTra)} (vnđ)</span>
            </div>
          </div>
        </p>{" "}
        <p>
          <div className="row">
            <div className="col-label-thong-tin-hd color7-bold">
              Số tiền đã trả:{" "}
            </div>
            <div className="col-3 text-left color7 color-xanh-bold">
              <span> {formatNumber(dataThongTinTra.SoTienDaTra)} (vnđ)</span>
            </div>
          </div>
        </p>{" "}
        <p>
          <div className="row">
            <div className="col-label-thong-tin-hd color7-bold">
              Số tiền còn phải trả:{" "}
            </div>
            <div className="col-3 text-left color7 color-do-bold">
              <span> {formatNumber(dataThongTinTra.SoTienConPhaiTra)} (vnđ)</span>
            </div>
          </div>
        </p>{" "}
                <p>
          <div className="row">
            <div className="col-label-thong-tin-hd color7-bold">
              Số ngày trả lãi:{" "}
            </div>
            <div className="col-3 text-left  text-normal color7">
              <span> {dataThongTinTra.SoNgayTraLai}</span>
            </div>
          </div>
        </p>{" "}
      </div>
      <div class="from-thongtintra">
        <p>
          <div className="row">
            <div className="col-label-thong-tin-hd color7-bold">
              Kiểu trả lãi:{" "}
            </div>
            <div className="col-3 text-left  text-normal color7">
              <span>{choVayConst.BeforeAfterText[hopdong.BeforeAfter]}</span>
            </div>
          </div>
        </p>
        <p>
          {" "}
          {hopdong.KieuLaiSuat === 3 ? (
            <div className="row">
              <div className="col-label-thong-tin-hd color7-bold">
                Kiểu trả lãi:{" "}
              </div>
              <div className="col-3 text-left color7 color-cam-bold">
                <span>
                  {choVayConst.KieuLaiSuatText[hopdong.KieuLaiSuat]}:{" "}
                  {item.LaiSuat.replace(/[/]Tháng$/, "")}
                </span>
              </div>
            </div>
          ) : hopdong.KieuLaiSuat === 2 ? (
            <div className="row">
              <div className="col-label-thong-tin-hd color7-bold">
                Kiểu trả lãi:{" "}
              </div>
              <div className="col-3 text-left color7 color-cam-bold">
                <span>
                  {choVayConst.KieuLaiSuatText[hopdong.KieuLaiSuat]}:{" "}
                  {item.LaiSuat}
                </span>
              </div>
            </div>
          ) : (
            <div className="row">
              <div className="col-label-thong-tin-hd color7-bold">
                Kiểu trả lãi:{" "}
              </div>
              <div className="col-3 text-left color7 color-cam-bold">
                <span>
                  {choVayConst.KieuLaiSuatText[hopdong.KieuLaiSuat]}:{" "}
                  {LaiSuatText2(hopdong, hopdong.KieuLaiSuat)}
                </span>
              </div>
            </div>
          )}
        </p>
      </div>
    </div>
  );
};
